/**
 * Fetch Admin Wallet Transactions UseCase
 * Admin variant of FetchWalletTransactionsUseCase: fetches ALL users'
 * transactions (no owner filter). Separate use case so the presentation layer
 * picks the path explicitly — no `isFromAdmin` flag on the chain below the hook.
 */
import { WalletService } from '@/domain/services/wallet/walletService';
import type { AppTransactionEntity } from '@/domain/entities/transaction/appTransactionEntity';
import type { PageCursor } from '@/data/types/json';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';

export class FetchAdminWalletTransactionsUseCase {
  private walletService: WalletService;

  constructor(walletService: WalletService = WalletService.getInstance()) {
    this.walletService = walletService;
  }

  async execute(
    cursor?: PageCursor,
    limit?: number,
  ): Promise<{ transactions: AppTransactionEntity[]; hasMore: boolean; cursor?: PageCursor }> {
    return this.walletService.fetchAdminTransactions(
      limit ?? SERVER_FETCH_CONSTANTS.DEFAULT_LIMIT,
      cursor,
    );
  }
}
